import { config } from "../../../../config/domain";
const RedirectnSource = window.localStorage.getItem("source");

export const segmentActivationMsg = Object.freeze({
    error: "There was some problem in raising service request. Please try again later.",
    createSR: {
      content : "We have received your request! Following segments will be activated in 3 working days:",
      redirectionText: "Back to Homepage",
      redirectionLink: RedirectnSource == "onep-sr" 
      ? config.onePlatformBase + "service-request" 
      : config.rootUrl + "clientarea/servicerequest",
    },
    SRexists: {
      headerText: "You have an active service request",
      content: "You have already raised this request for the day.",
    }
});
export const validationMsg = {
    TradingSatusRemark: { err: " Your trading account status is inactive." },
    CASHSegmentRemark: { err: "All other segments can be activated only if CASH segment in BSE or NSE is active." },
    CKYCRemark: { err: "Your CKYC is not registered. Go to Service Request > Create Service Request > CKYC Update, to update the same." },
    IncomeOrNetworthRemark: { err: "Please declare your latest income to proceed with Segment Activation as income is not  updated or income declared by you is over one year old. Go to Service Request > Create Service Request > Income Declaration, to update the same." },
    DormantRemark: { err: "Your account is deactivated. Please reactivate your account to proceed with segment activation." },
    Name_Match: { err: "You are not permitted to trade as Name in your trading account is not matching with PAN. Please connect with your Relationship Manager or contact our nearest branch for the same." },
    KRARemark: { err: "Your KRA validation is pending. Without KRA validation, transactions in your account are not allowed as per regulation. Please validate KRA to proceed with Segment Activation.", }
}
export const segmentNamesSMS = {
    NSEFO: "Equity Derivatives",
    BSEFO: "Equity Derivatives",
    NSECDS: "Currency Derivatives",
    BSECDS: "Currency Derivatives",
    SLBM: "SLBM",
    COMMCX: "",
    COMNCDEX: "Commodity Derivatives"
}
export const segmentIncomeProof = [
    {
      display: "6 Months Bank Statement",
      value: "SixMonthsBankStatement",
      desc: "Latest self attested 6 months bank statement (not older than 3 months).  Bank statement should contain client's name, account number, period and bank's logo. If logo is not available then Bank's stamp & signature is required.",
    },
    {
      display: "ITR Proof",
      value: "ITRProof",
      desc: "Latest self attested ITR copy.",
    },
    {
      display: "Demat Holdings",
      value: "DematHoldings",
      desc: "Latest self attested demat holdings statement required. If, it is non-EBL DP then DP seal & signature is mandatory on the holding statement.",
    },
    {
      display: "Salary Slip",
      value: "SalarySlip",
      desc: "Latest self attested salary slip required. Name on salary slip should match with client's name and it should contain employer's logo. If employer's logo is not available then employer's stamp & HR signature is required.",
    },
    {
      display: "Net-worth Certificate",
      value: "NetworthCertificate",
      desc: "Self attested latest net - worth certificate with CA stamp & signature required.",
    },
];
export const allowedSegmentsEQ = ['NSEFO', 'NSECDS', 'SLBM'];
export const allowedSegmentsCOM = ['MCX', 'NCDEX'];
export const allowedSegmentsComEq = ['NSEFO', 'NSECDS', 'SLBM', 'MCX', 'NCDEX'];